<template>
  <div class="append-box">
    <v-mask style="background:ragb(0,0,0,0.5);" @touchmove="gtouchmove" v-show="show"></v-mask>
    <div class="small-game-box" v-show="show">
      <div v-bind:class="{'animated baisonFadeInDown small-game':true,'baisonFadeInUp':fadeOut}">
        <div class="card-list-box">
          <div class="card-list">
            <div class="card-item" v-for="(item,index) in list" v-bind:key="index">
              <div class="card-border" v-show="chooseIndex==index && showPokerSunlight"></div>
              <div
                class="abs-center-box sunlight-box"
                v-show="chooseIndex==index && showPokerSunlight"
              >
                <div class="sunlight"></div>
              </div>
              <div class="card-wrapper" @click="handleChooseCard(index)">
                <div
                  v-bind:class="{'card':true,'active':item.back && chooseIndex==index,'activeTimeout':item.back && chooseIndex!=index}"
                >
                  <div v-show="!item.back && chooseIndex==-1" class="pointer"></div>
                  <div class="card-face card-front"></div>
                  <div v-bind:class="getCardBackStyle(item.multiple)"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="abs-center-box result-box" v-show="showResult">
            <div class="abs-center-box sunlight-box" v-show="showResultSunlight">
              <div class="sunlight"></div>
            </div>
            <div class="horizontal-center win-result-box" v-show="showWinResult">
              <div class="win-result-bg">
                <div class="win-result" v-html="getWinMoneyImg(WinGold)"></div>
              </div>
            </div>
            <div class="result-bg">
              <div class="abs-center-box result">
                <img
                  :src="getWinResultImg(winMultiple)"
                  ondragstart="return false;"
                  class="result-img"
                />
              </div>
            </div>
          </div>
        </div>
        <p class="white horizontal-center p-money" v-if="!showWinResult">下注金额：{{Bet/10000}}</p>
        <p class="white horizontal-center p-tips" v-if="!showResult">
          请点击选择一张扑克牌翻开,
          <span class="time">{{time}}s</span>后不选择将自动翻开
        </p>
        <div v-else class="animated fadeIn horizontal-center op-box">
          <btn @click="handleConfirm(1)" v-preventReClick="2000" v-clickMusic class="btn" text></btn>
          <btn @click="handleConfirm(2)" v-preventReClick="2000" v-clickMusic class="btn2" text></btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vmask from "@/components/mask.vue";
import store from "@/store/index";
import btn from "@/components/btn.vue";
import { deepClone, shuffle } from "@/utils/index";
import soundManager from "@/utils/soundManager";
import ifmTool from "@/utils/ifmTool";
import preload from "@/utils/preload";
const showResultSunlightDelay = 300;
const showResultDelay = 300;
const showWinResultDelay = 100;
const showPokerSunlightDelay = 500;
const winNumberImg = {
  "+": require("@/assets/img/small-game/win/jiahao.png"),
  ".": require("@/assets/img/small-game/win/dian.png"),
  "0": require("@/assets/img/small-game/win/0.png"),
  "1": require("@/assets/img/small-game/win/1.png"),
  "2": require("@/assets/img/small-game/win/2.png"),
  "3": require("@/assets/img/small-game/win/3.png"),
  "4": require("@/assets/img/small-game/win/4.png"),
  "5": require("@/assets/img/small-game/win/5.png"),
  "6": require("@/assets/img/small-game/win/6.png"),
  "7": require("@/assets/img/small-game/win/7.png"),
  "8": require("@/assets/img/small-game/win/8.png"),
  "9": require("@/assets/img/small-game/win/9.png"),
};
const loseNumberImg = {
  "-": require("@/assets/img/small-game/lose/jianhao.png"),
  ".": require("@/assets/img/small-game/lose/dian.png"),
  "0": require("@/assets/img/small-game/lose/0.png"),
  "1": require("@/assets/img/small-game/lose/1.png"),
  "2": require("@/assets/img/small-game/lose/2.png"),
  "3": require("@/assets/img/small-game/lose/3.png"),
  "4": require("@/assets/img/small-game/lose/4.png"),
  "5": require("@/assets/img/small-game/lose/5.png"),
  "6": require("@/assets/img/small-game/lose/6.png"),
  "7": require("@/assets/img/small-game/lose/7.png"),
  "8": require("@/assets/img/small-game/lose/8.png"),
  "9": require("@/assets/img/small-game/lose/9.png"),
};
const preloadUrls = [
  require("@/assets/img/small-game/shou1.png"),
  require("@/assets/img/small-game/shou2.png"),
  require("@/assets/img/small-game/button1.png"),
  require("@/assets/img/small-game/button2.png"),
  require("@/assets/img/small-game/ditu1.png"),
  require("@/assets/img/small-game/kuang.png"),
  require("@/assets/img/small-game/sun.png"),
  require("@/assets/img/small-game/poker/paibei.png"),
  require("@/assets/img/small-game/poker/mingbai1.png"),
  require("@/assets/img/small-game/poker/mingbai1.2.png"),
  require("@/assets/img/small-game/poker/mingbai1.5.png"),
  require("@/assets/img/small-game/poker/mingbai2.png"),
  require("@/assets/img/small-game/poker/mingbai3.png"),
  require("@/assets/img/small-game/poker/mingbai4.png"),
  require("@/assets/img/small-game/poker/mingbai5.png"),
  require("@/assets/img/small-game/result-bg.png"),
  require("@/assets/img/small-game/hset.png"),
  require("@/assets/img/small-game/xxcyu.png"),
  require("@/assets/img/small-game/x1.2.png"),
  require("@/assets/img/small-game/x1.5.png"),
  require("@/assets/img/small-game/x2.png"),
  require("@/assets/img/small-game/x3.png"),
  require("@/assets/img/small-game/x4.png"),
  require("@/assets/img/small-game/x5.png"),
];
export default {
  name: "poker",
  components: {
    "v-mask": vmask,
    btn,
  },
  data() {
    return {
      MiniGameId: 7000,
      WinPos: 0,
      WinGold: 0,
      ResultList: [],
      Bet: 0,
      show: false,
      time: 4,
      fadeOut: false,
      showResult: false,
      winMultiple: 0,
      chooseIndex: -1,
      showResultSunlight: false,
      showPokerSunlight: false,
      showWinResult: false,
      list: [
        {
          back: false,
        },
        {
          back: false,
        },
        {
          back: false,
        },
        {
          back: false,
        },
        {
          back: false,
        },
      ],
      timer: null,
      hasChoose: false,
    };
  },
  computed: {
    closeAllPopUp() {
      return store.state.app.closeAllPopUp;
    },
  },
  mounted() {},
  watch: {
    closeAllPopUp() {
      this.close();
    },
    showResult() {
      if (this.WinGold > 0) {
        this.playEffect("win");
      } else {
        this.playEffect("lose");
      }
      if (this.showResult) {
        setTimeout(() => {
          this.showResultSunlight = true;
        }, showResultSunlightDelay);
      }
    },
    showResultSunlight() {
      if (this.showResultSunlight) {
        setTimeout(() => {
          this.showWinResult = true;
        }, showWinResultDelay);
      }
    },
    chooseIndex() {
      if (this.chooseIndex > -1) {
        setTimeout(() => {
          this.showPokerSunlight = true;
        }, showPokerSunlightDelay);
      }
    },
    showPokerSunlight() {
      if (this.showPokerSunlight) {
        setTimeout(() => {
          this.showResult = true;
        }, showResultDelay);
      }
    },
  },
  created() {
    window.__loading = this.$loading({
      text: "加载中",
      showLogo: false,
    });
    new preload(preloadUrls, () => {
      if (window.__loading) {
        window.__loading.close();
        window.__loading = null;
      }
      this.show = true;
      this.startTimer();
    });
  },
  methods: {
    startTimer() {
      //开始计时器
      if (this.timer != null) {
        window.clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          this.$nextTick(() => {
            window.clearInterval(this.timer);
            setTimeout(() => {
              this.handleChooseCard(0);
            }, 1000);
          });
        }
      }, 1000);
    },
    //播放音效
    playEffect(key) {
      //全局只能有一个音效播放实例
      if (!window.soundEffectInstance) {
        window.soundEffectInstance = new soundManager();
      }
      //gameID key 音效名称
      window.soundEffectInstance.playEffect(100, key);
    },
    getCardBackStyle(multiple) {
      let cla = "card-face card-back ";
      switch (String(multiple)) {
        case "0":
          cla += "card-back-multiple0";
          break;
        case "1.2":
          cla += "card-back-multiple1-2";
          break;
        case "1.5":
          cla += "card-back-multiple1-5";
          break;
        case "2":
          cla += "card-back-multiple2";
          break;
        case "3":
          cla += "card-back-multiple3";
          break;
        case "4":
          cla += "card-back-multiple4";
          break;
        case "5":
          cla += "card-back-multiple5";
          break;
        default:
          cla += "card-back-multiple-unknow";
          break;
      }
      return cla;
    },
    getWinResultImg(multiple) {
      let img = "";
      switch (String(multiple)) {
        case "0":
          img = require("@/assets/img/small-game/xxcyu.png");
          break;
        case "1.2":
          img = require("@/assets/img/small-game/x1.2.png");
          break;
        case "1.5":
          img = require("@/assets/img/small-game/x1.5.png");
          break;
        case "2":
          img = require("@/assets/img/small-game/x2.png");
          break;
        case "3":
          img = require("@/assets/img/small-game/x3.png");
          break;
        case "4":
          img = require("@/assets/img/small-game/x4.png");
          break;
        case "5":
          img = require("@/assets/img/small-game/x5.png");
          break;
        default:
          img = require("@/assets/img/small-game/xxcyu.png");
          break;
      }
      return img;
    },
    getWinMoneyImg(winGold) {
      winGold = Math.floor(((winGold - this.Bet) / 10000) * 100) / 100;
      let winGoldArr = [];
      let numberImg = [];
      if (Number(winGold) > 0) {
        winGoldArr = String(winGold).split("");
        numberImg = winNumberImg;
        winGoldArr.unshift("+");
      } else {
        winGoldArr = String(winGold).split("");
        numberImg = loseNumberImg;
      }
      let winGoldImgArr = [];
      for (let i = 0; i < winGoldArr.length; i++) {
        winGoldImgArr.push(
          `<img src="${
            numberImg[winGoldArr[i]]
          }" ondragstart="return false;" style="height: 0.27rem;margin-top: 0.035rem;" />`
        );
      }
      return winGoldImgArr.join("");
    },
    close() {
      this.fadeOut = true;
      setTimeout(() => {
        if (this.$el.parentNode) {
          this.$el.parentNode.removeChild(this.$el);
        }
        this.$destroy(true);
      }, 300);
    },
    handleConfirm(type) {
      store.dispatch("setGaussianBlur", false);
      if (type == 1) {
        ifmTool.confirmGame();
        this.close();
      } else {
        ifmTool.nextGame();
        this.close();
      }
    },
    handleChooseCard(postIndex) {
      if (this.hasChoose) {
        return;
      }
      this.hasChoose = true;
      if (this.timer != null) {
        window.clearInterval(this.timer);
      }
      //打乱传过来的数组
      const resultList = shuffle(this.ResultList);
      for (let i = 0; i < resultList.length; i++) {
        if (i == postIndex && resultList[i].pos == this.WinPos) {
          resultList[i].back = true;
          this.chooseIndex = i;
          this.winMultiple = resultList[i].multiple;
        } else {
          if (resultList[i].pos == this.WinPos) {
            const t = resultList[i];
            resultList[i] = resultList[postIndex];
            resultList[postIndex] = t;
            resultList[postIndex].back = true;
            this.chooseIndex = postIndex;
            this.winMultiple = resultList[postIndex].multiple;
          } else {
            resultList[i].back = false;
          }
        }
      }
      this.list = resultList;
      ifmTool.updateAccountBalance();
      this.playEffect("pokerFlip");
      this.$nextTick(() => {
        setTimeout(() => {
          var copyList = deepClone(this.list);
          copyList.forEach((value) => {
            value.back = true;
          });
          this.list = copyList;
        }, showPokerSunlightDelay);
      });
    },
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
  },
};
</script>

<style lang="scss" scoped>
.append-box {
  z-index: 88889;
  .img-loading {
    z-index: 301;
    .sp {
      color: #37b9ff;
    }
  }
  .small-game-box {
    position: fixed;
    z-index: 301;
    width: 6.125rem;
    height: 3.75rem;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 0.115rem;
    .small-game {
      width: 100%;
      height: 100%;
      -webkit-animation-duration: 0.3s;
      animation-duration: 0.3s;

      .white {
        color: #d7d7d7;
      }
      .time {
        color: #00f032;
      }
      .p-money {
        top: 3.05rem;
        font-weight: bold;
        font-size: 0.15rem;
      }
      .p-tips {
        top: 3.3rem;
      }
      .op-box {
        top: 3.3rem;
        display: flex;
        width: 6rem;
        margin: 0 auto;
        align-items: center;
        z-index: 999;
        .btn {
          background: url(~@/assets/img/small-game/button1.png) no-repeat;
          background-size: cover;
          width: 1.4rem;
          height: 0.33rem;
        }
        .btn2 {
          background: url(~@/assets/img/small-game/button2.png) no-repeat;
          background-size: cover;
          width: 1.4rem;
          height: 0.33rem;
        }
      }
      .card-list-box {
        height: 2.96rem;
        width: 100%;
        position: absolute;
        top: 0.12rem;
        background-image: url(~@/assets/img/small-game/ditu1.png);
        background-repeat: no-repeat;
        background-size: cover;
        .card-list {
          margin: 0 auto;
          margin-top: 1.2rem;
          width: 5.375rem;
          display: table;
          height: 1.345rem;
          .card-item {
            display: table-cell;
            position: relative;
            .card-border {
              width: 1.065rem;
              height: 1.4rem;
              position: absolute;
              top: -0.06rem;
              left: 0;
              background: url(~@/assets/img/small-game/kuang.png) no-repeat;
              background-size: contain;
              z-index: 1;
            }
            .sunlight-box {
              width: 1.65rem;
              height: 1.645rem;
              .sunlight {
                width: 100%;
                height: 100%;
                background: url(~@/assets/img/small-game/sun.png) no-repeat;
                background-size: cover;
                animation: sunlight-round 1.5s linear infinite;
              }
            }
            .card-wrapper {
              width: 1.09rem;
              height: 1.345rem;
              margin: 0 auto;
              .card {
                width: 100%;
                height: 100%;
                outline: none;
                -webkit-tap-highlight-color: transparent;
                transform-style: preserve-3d;
                position: relative;
                transition: transform 0.5s;
                &.active {
                  animation: card-active 0.5s cubic-bezier(0, 0, 0.05, 0.64)
                    forwards;
                }
                &.activeTimeout {
                  transform: rotateY(180deg);
                }
                .pointer {
                  position: absolute;
                  width: 0.465rem;
                  height: 0.44rem;
                  bottom: 0.3rem;
                  right: 0.15rem;
                  z-index: 2;
                  background: url(~@/assets/img/small-game/shou1.png) no-repeat;
                  background-size: cover;
                  animation: pointer-change-bg 0.5s infinite linear;
                  animation-delay: 0.5s;
                }
                .card-face {
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  z-index: 1;
                  backface-visibility: hidden;
                  &.card-front {
                    background: url(~@/assets/img/small-game/poker/paibei.png)
                      no-repeat;
                    background-size: cover;
                  }
                  &.card-back {
                    transform: rotateY(180deg);
                    &.card-back-multiple-unknow {
                      background: url(~@/assets/img/small-game/poker/paibei.png)
                        no-repeat;
                      background-size: cover;
                    }
                    &.card-back-multiple0 {
                      background: url(~@/assets/img/small-game/poker/mingbai1.png)
                        no-repeat;
                      background-size: cover;
                    }
                    &.card-back-multiple1-2 {
                      background: url(~@/assets/img/small-game/poker/mingbai1.2.png)
                        no-repeat;
                      background-size: cover;
                    }
                    &.card-back-multiple1-5 {
                      background: url(~@/assets/img/small-game/poker/mingbai1.5.png)
                        no-repeat;
                      background-size: cover;
                    }
                    &.card-back-multiple2 {
                      background: url(~@/assets/img/small-game/poker/mingbai2.png)
                        no-repeat;
                      background-size: cover;
                    }
                    &.card-back-multiple3 {
                      background: url(~@/assets/img/small-game/poker/mingbai3.png)
                        no-repeat;
                      background-size: cover;
                    }
                    &.card-back-multiple4 {
                      background: url(~@/assets/img/small-game/poker/mingbai4.png)
                        no-repeat;
                      background-size: cover;
                    }
                    &.card-back-multiple5 {
                      background: url(~@/assets/img/small-game/poker/mingbai5.png)
                        no-repeat;
                      background-size: cover;
                    }
                  }
                }
              }
            }
          }
        }
        .result-box {
          width: 3.2rem;
          height: 1.545rem;
          z-index: 3;
          .sunlight-box {
            width: 4rem;
            height: 4rem;
            .sunlight {
              width: 100%;
              height: 100%;
              background: url(~@/assets/img/small-game/sun.png) no-repeat;
              background-size: cover;
              animation: sunlight-round 1.5s linear infinite;
            }
          }
          .result-bg {
            background: url(~@/assets/img/small-game/result-bg.png) no-repeat;
            background-size: cover;
            width: 100%;
            height: 100%;
            display: block;
            position: relative;
            transform: scale(0);
            opacity: 0;
            animation: show-result 0.3s cubic-bezier(0, 0, 0, 1) forwards;
            .result {
              height: 0.85rem;
              margin-top: -0.02rem;
              .result-img {
                width: 2.315rem;
                height: 0.63rem;
                margin-top: 0.11rem;
              }
            }
          }
          .win-result-box {
            bottom: -0.55rem;
            z-index: 1;
            .win-result-bg {
              width: 1.975rem;
              height: 0.47rem;
              display: block;
              background: url(~@/assets/img/small-game/hset.png) no-repeat;
              background-size: cover;
              float: left;
              transform: scaleX(0);
              animation: win-result-show 0.3s linear forwards;
              .win-result {
                width: 1.75rem;
                height: 0.34rem;
                display: block;
                margin: 0 auto;
                margin-top: 0.04rem;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
}
@media all and (orientation: portrait) {
  .append-box {
    .small-game-box {
      transform: translate(-50%, -50%) rotate(90deg);
    }
  }
}
@keyframes sunlight-round {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(270deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes pointer-change-bg {
  0% {
    background: url(~@/assets/img/small-game/shou1.png) no-repeat;
    background-size: cover;
  }
  10% {
    background: url(~@/assets/img/small-game/shou2.png) no-repeat;
    background-size: cover;
  }
  20% {
    background: url(~@/assets/img/small-game/shou2.png) no-repeat;
    background-size: cover;
  }
  30% {
    background: url(~@/assets/img/small-game/shou2.png) no-repeat;
    background-size: cover;
  }
  40% {
    background: url(~@/assets/img/small-game/shou2.png) no-repeat;
    background-size: cover;
  }
  50% {
    background: url(~@/assets/img/small-game/shou2.png) no-repeat;
    background-size: cover;
  }
  60% {
    background: url(~@/assets/img/small-game/shou1.png) no-repeat;
    background-size: cover;
  }
  70% {
    background: url(~@/assets/img/small-game/shou1.png) no-repeat;
    background-size: cover;
  }
  80% {
    background: url(~@/assets/img/small-game/shou1.png) no-repeat;
    background-size: cover;
  }
  90% {
    background: url(~@/assets/img/small-game/shou1.png) no-repeat;
    background-size: cover;
  }
  100% {
    background: url(~@/assets/img/small-game/shou1.png) no-repeat;
    background-size: cover;
  }
}

@keyframes card-active {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
  75% {
    transform: scale(1);
  }
  100% {
    transform: rotateY(180deg);
  }
}

@keyframes show-result {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  10% {
    transform: scale(0.1);
    opacity: 0.3;
  }
  20% {
    transform: scale(0.2);
    opacity: 0.6;
  }
  30% {
    transform: scale(0.4);
    opacity: 0.8;
  }
  40% {
    transform: scale(0.6);
    opacity: 0.9;
  }
  50% {
    transform: scale(0.8);
    opacity: 1;
  }
  60% {
    transform: scale(1);
    opacity: 1;
  }
  70% {
    transform: scale(1.03);
    opacity: 1;
  }
  80% {
    transform: scale(1.03);
    opacity: 1;
  }
  90% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes win-result-show {
  0% {
    transform: scaleX(0);
  }
  50% {
    transform: scaleX(1.1);
  }
  100% {
    transform: scaleX(1);
  }
}
</style>